'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreationActionTypes = (0, _keyMirror2.default)({
  CREATION_ATTEMPTED: null,
  CREATION_SUCCEEDED: null,
  CREATION_FAILED: null,
  CREATION_LOOP_DETECTED: null,
  RESET_CREATION: null
});

exports.default = CreationActionTypes;
module.exports = exports['default'];